import { render, staticRenderFns } from "./CognitionOfDerivatives.vue?vue&type=template&id=56c44d2f&scoped=true&"
import script from "./CognitionOfDerivatives.vue?vue&type=script&lang=js&"
export * from "./CognitionOfDerivatives.vue?vue&type=script&lang=js&"
import style0 from "./CognitionOfDerivatives.vue?vue&type=style&index=0&id=56c44d2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c44d2f",
  null
  
)

export default component.exports